import {TestResults,MainCategories} from 'Models'
export default {
    computed: {
        mainCategoryItems()
        {
            const createMainCatItems = mc => this.createMainCategoryItem(MainCategories.findById(mc), this.userAnswers)

            return this.mainCategoryIds.map(createMainCatItems)
        },

        testResultsSavedToBackend()
        {
            return TestResults.savedToBackend()
        },
    },
    methods: {
        createMainCategoryItem(mainCategory, userAnswers)
        {
            let forMaincategory = a => a.mainCategoryId() === mainCategory.id()
            const answers       = userAnswers.filter( forMaincategory )
            const countCorrect = answers.reduce((acc,a) => acc + a.realNumCorrectAnswers(), 0)
            const countIncorrect = answers.reduce((acc,a) => acc + a.realNumWrongAnswers(), 0)

            return {
                id:             mainCategory.id(),
                icon:           mainCategory.image(),
                title:          mainCategory.name(),
                countCorrect:   countCorrect,
                countIncorrect: countIncorrect,
                countAll: answers.length,
                percentCorrect: countCorrect + countIncorrect > 0 ? ( countCorrect / ( countCorrect + countIncorrect )  * 100).toFixed(2) : 0,
                hasCorrect:     true,
                hasIncorrect:   true
            }
        },
        onMainCategoryClick(itemID)
        {
            this.$emit('clicked', itemID)
        },
        onGoToRevisionCenter()
        {
            this.$router.replace({ name: 'testStats' })
        },
    }
};